import React, { useEffect, useState } from "react";
import { Modal,Alert ,Button} from 'antd';
import { connect } from "react-redux";
import apicalls from "../../api/apiCalls";
import {useLocation,useParams } from 'react-router-dom'
const AddCardComponent = (props) => {
    const [loader, setLoader] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null)
    const [cardType,setCardType]=useState(null)
     const location=useLocation()
     const {custId} = useParams();
  useEffect(()=>{
    let data=location.pathname.split('/')
    setCardType(data[5]?.toLowerCase())
  },[])

    const saveNewCard = async () => {
        setLoader(true);
        let obj = {
         "cardType": cardType
        }
        let response = await apicalls.saveCreateCard(custId, obj)
        if (response.ok) {
            if(cardType=="physical"){
                setLoader(false);
                props?.onCancel()
                props?.getphysicalCards()
                setErrorMsg(null)
            }else{
                setLoader(false);
                props?.onCancel()
                props?.getvirtualCards()
                setErrorMsg(null)

            }
        }
        else {
            setLoader(false);
            props?.onCancel()
            setErrorMsg(apicalls.isErrorDispaly(response))
        }

    }

    return (
        <>
            <Modal
                className="create-card"
                title={<div className="d-flex justify-content-between"><>Create Card Confirmation</><span className="icon close c-pointer" onClick={props?.onCancel} ></span></div>}
                visible={props?.modal}
                onOk={saveNewCard}
                onCancel={props?.onCancel}
                footer={[
                    <Button key="back" onClick={props?.onCancel}>
                      Cancel
                    </Button>,
                    <Button key="submit" type="primary" loading={loader} onClick={()=>saveNewCard()} className="primary-btn">
                      OK
                    </Button>,
                  ]}
            >
                {errorMsg !== undefined && errorMsg !== null && (
                    <Alert variant="danger" className='alert-flex' description={errorMsg} showIcon>
                        <p style={{ color: 'red', margin: 10 }}><span className="icon error-alert me-2"></span>{errorMsg}</p>
                    </Alert>
                )}
                <p>By creating your card, you will be able to make purchases and add new payment methods. However, it is important to note that before proceeding, you must deposit money into your fiat wallet.</p>

            </Modal>
        </>
    )
}

const connectStateToProps = ({ userConfig, oidc }) => {
    return { userConfig: userConfig?.userProfileInfo, user: oidc?.user }
  }

const connectDispatchToProps = (dispatch) => {
    return {

        dispatch,
    };
};
export default connect(
    connectStateToProps,
    connectDispatchToProps
)(AddCardComponent)
